import React from 'react';
import { Box, Divider } from '@mui/material';

import { FeaturePatternTrussSettings } from '@paragon/contract-library';
import { PropertiesPanel } from '@paragon/layout-models';

import { FeaturePatternTrussShapeDetails } from '../../insertions/component/shape-details/FeaturePatternTrussShapeDetails';
import { FeaturePatternTrussStructuralDetails } from '../../insertions/component/structural-details/FeaturePatternTrussStructuralDetails';
import { SettingsControlsProps } from '../interfaces';
import { SettingsControlsPresetToolbar } from '../preset-toolbar/SettingsControlsPresetToolbar';

export interface FeaturePatternSettingsControlsProps extends SettingsControlsProps<FeaturePatternTrussSettings> {
  readonly showHeader?: boolean /** default: true */;
  readonly showPresetControls?: boolean /** default: true */;
}

export function FeaturePatternSettingsControls(props: FeaturePatternSettingsControlsProps) {
  return (
    <PropertiesPanel title={props.showHeader !== false ? 'Feature Pattern Settings' : undefined}>
      {props.showPresetControls !== false && (
        <>
          <SettingsControlsPresetToolbar
            settings={props.settingsObject}
            settingsType="featurePatternTrussSettings"
            onOverwriteSettingsFromPreset={props.onChange}
          />
          <Divider />
        </>
      )}
      <Box sx={{ m: 2 }}>
        <FeaturePatternTrussShapeDetails value={props.settingsObject} onChange={props.onChange} />
        <FeaturePatternTrussStructuralDetails value={props.settingsObject} onChange={props.onChange} />
      </Box>
    </PropertiesPanel>
  );
}
